/**
 * Sites ouverts en lecture seule : lorsque le périmètre sélectionné correspond à
 * l'un d'eux, les actions de création, modification et suppression sont masquées
 * sur l'ensemble des écrans.
 */
export const READ_ONLY_SITE_IDS: string[] = [
    'site_202edbd1e521d29f0881224b9c001ace'
];
